import { render } from "./TabSessions.vue?vue&type=template&id=bf70d542&scoped=true"
import script from "./TabSessions.vue?vue&type=script&lang=js"
export * from "./TabSessions.vue?vue&type=script&lang=js"

import "./TabSessions.vue?vue&type=style&index=0&id=bf70d542&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf70d542"]])

export default __exports__